import { render, staticRenderFns } from "./GuestPortal.vue?vue&type=template&id=5a90b922&scoped=true"
import script from "./GuestPortal.vue?vue&type=script&lang=js"
export * from "./GuestPortal.vue?vue&type=script&lang=js"
import style0 from "./GuestPortal.vue?vue&type=style&index=0&id=5a90b922&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a90b922",
  null
  
)

export default component.exports